<h1 mat-dialog-title>{{this.taskName}} Time Block</h1>
<div mat-dialog-content>
  <div class="layout">
    <div class="column endpoint-picker">
      <app-datetime-picker
                           label="Start"
                           [lowerBound]="this.startLowerBound"
                           [upperBound]="this.startUpperBound"
                           [(selection)]="this.selectedStart">
      </app-datetime-picker>
    </div>

    <div class="column duration" *ngIf="this.selectedEnd">
      <div>
        <span class="flex-spacer"></span>
        <span>{{this.formattedDuration}}</span>
        <span class="flex-spacer"></span>
      </div>
      <div class="arrow">
        <span class="flex-spacer"></span>
        <mat-icon>arrow_right</mat-icon>
      </div>
      <div>
        <span class="flex-spacer"></span>
        <span>{{this.durationDelta}}</span>
        <span class="flex-spacer"></span>
      </div>
    </div>

    <div class="column endpoint-picker" *ngIf="this.selectedEnd">
      <app-datetime-picker
                           label="End"
                           [lowerBound]="this.endLowerBound"
                           [upperBound]="this.endUpperBound"
                           [(selection)]="this.selectedEnd">
      </app-datetime-picker>
    </div>
  </div>

</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>CANCEL</button>
  <button mat-button
          [disabled]="!this.canSubmit"
          [mat-dialog-close]="this.getResult()">SAVE</button>
</div>